import React from "react";
import {RaccoltaCalendarEvent} from "../../../types";
import {ALERT, GOCCIA} from "../../../constants/svgs";
import theme, {FONTS} from "../../../constants/theme";
import {Box, styled, SxProps, Theme} from "@mui/material";
import Text from "../../text";
import CustomSvg from "../../custom-svg";
import {buildPath, isEventPast, scale} from "../../../utils";
import {EventProps} from "react-big-calendar";
import {useLocation, useNavigate} from "react-router-dom";
import {useMediaQuery} from "@mui/system";

interface Props {
  day: EventProps<RaccoltaCalendarEvent>;
}

const Wrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: scale(28),
  justifyContent: 'space-between',
  paddingLeft: scale(6),
  [theme.breakpoints.down('sm')]: {
    height: scale(25),
    paddingTop: 0,
    paddingLeft: scale(7),
  },
});

const IconBox = styled(Box)({
  height: scale(18),
  display: 'flex',
})

const svgStyle: SxProps<Theme> = {
  height: scale(20),
  width: scale(13.14),
}

const EventComponent = ({day}: Props) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;

  const isOperatore = path.includes('operatore');

  const urlRaccolta = isOperatore ? `/operatore/dettaglio-raccolta/${day.event.id}` : `/donatore/raccolta/${day.event.id}`

  const eventDate = new Date(day.event.start);
  const eventIsPast = isEventPast(eventDate);

  return (
    <Wrapper onClick={() => {
      if (!isOperatore && eventIsPast) {
        return
      }
      navigate(buildPath(urlRaccolta))
    }}>
      {day.event.hasNota && (
        <>
          {!isMobile && (
            <IconBox>
              <CustomSvg
                  svg={ALERT}
                  sx={svgStyle}
              />
            </IconBox>
          )}
        </>
      )}
      <Text
        text={day.event.name}
        fontFamily={FONTS.MONTSERRAT}
        fontSize={isMobile ? scale(12) : scale(14)}
        fontWeight={'bold'}
        sx={{
          height: scale(18),
          maxWidth: '76%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          alignSelf: 'anchor-center',
          [theme.breakpoints.down('sm')]: {
            maxWidth: '80%',
            position: 'relative',
          },
        }}
      />
      {day.event.type && (day.event.type === 'plasma' || day.event.type === 'sangue') && (
        <>
          {!isMobile ? (
            <IconBox>
              <CustomSvg
                svg={GOCCIA}
                cls1Color={day.event.type === 'sangue' ? theme.palette.blood.main : theme.palette.plasma.main}
                sx={svgStyle}
              />
            </IconBox>
          ) : (
            <Box
              sx={{
                backgroundColor: day.event.type === 'sangue' ? theme.palette.blood.main : theme.palette.plasma.main,
                height: '100%',
                width: scale(5),
              }}
            />
          )}
        </>
      )}
      {day.event.type && day.event.type === 'plasma & sangue' && (
        <>
          {!isMobile ? (
            <IconBox>
              <CustomSvg
                svg={GOCCIA}
                cls1Color={theme.palette.plasma.main}
                sx={svgStyle}
              />
              <CustomSvg
                svg={GOCCIA}
                cls1Color={theme.palette.blood.main}
                sx={svgStyle}
              />
            </IconBox>
          ) : (
            <Box sx={{display: 'flex', flexDirection: 'column', height: '100%'}}>
              <Box
                sx={{
                  backgroundColor: theme.palette.plasma.main,
                  height: '50%',
                  width: scale(5),
                }}
              />
              <Box
                sx={{
                  backgroundColor: theme.palette.blood.main,
                  height: '50%',
                  width: scale(5),
                }}
              />
            </Box>
          )}
        </>
      )}
    </Wrapper>
  );
}

export default EventComponent;
